import React, { Component } from "react";
import { toast } from "react-toastify";
import BaseForm from "./../common/baseForm";
import SubscriptionsTable from "./../subscriptionsTable";
import BillingProfile from "./../billingProfile";
import UserParsedHouseEventsTable from "./userParsedHousesEventsTable";
import MessagesTable from "./messagesTable";
import DefaultPanelContainer from "./../common/defaultPanelContainer";
import auth from "./../../services/authService";
import { Container, Row, Col, Button } from "reactstrap";
import http from "../../services/httpService";
import PaymentsTable from "./../paymentsTable";
import SearchProfilesTable from "./../searchProfilesTable";
import UserForm from "./userForm";
import { AdminPermission, CustomerServicePermission } from "../adminPermission";
import UserCustomerServiceForm from "./userCustomerServiceForm";
import BlockedWebsitesTable from "./../blockedWebsitesTable";
import UserListingStatusesTable from "./userListingStatusesTable";

class UserDetails extends Component {
  state = {
    isLoaded: false,
    tree: [],
    billingProfile: {},
    userDetails: null,
  };

  loadBillingProfile = async () => {
    if (this.props.match.params.id === "new") return;
    const { data } = await http.get(
      "billingprofiles/" + this.props.match.params.id
    );

    this.setState({ billingProfile: data });
  };

  loadUserDetails = async () => {
    if (this.props.match.params.id === "new") return;
    const { data } = await http.get(
      "users/edit/" + this.props.match.params.id
    );
    this.setState({ userDetails: data });
  };

  async componentDidMount() {
    await this.loadBillingProfile();
    await this.loadUserDetails();
  }

  doUnsubscribe = async (confirmationMessage, path, successMessage) => {
    if (window.confirm(confirmationMessage)) {
      await http.put(path + this.props.match.params.id);
      toast.success(successMessage);
      // await this.loadSearchProfile(data);
      await this.loadBillingProfile();

      this.setState({ loading: false });
    }
  };

  handleUnsubscribeClick = async () => {
    await this.doUnsubscribe(
      "Are you sure you want to unsubscribe this user",
      "users/unsubscribe/",
      "user sucessfully unsubscribed"
    );
  };

  handleUnsubscribeAndNotifyClick = async () => {
    await this.doUnsubscribe(
      "Are you sure you want to unsubscribe and notify this user by email",
      "users/unsubscribeandnotify/",
      "user sucessfully unsubscribed and notified"
    );
  };

  handleDeleteForeverClick = async () => {
    if (window.confirm("Are you sure. This operation cannot be undone")) {
      try {
        await http.delete("users/delete/" + this.props.match.params.id);
        toast.success("user sucessfully deleted");
      } catch (ex) {
        if (ex.response && ex.response.status === 400) {
          const errors = { ...this.state.errors };
          errors.username = ex.response.data;
          this.setState({ errors });
        }
      }
    }
  };

  handlePauseClick = async () => {
    if (window.confirm("Are you sure you want to pause this user's account? They will stop receiving listings.")) {
      try {
        await http.put("users/pause/" + this.props.match.params.id);
        toast.success("Account successfully paused");
        await this.loadUserDetails();
      } catch (ex) {
        const message = ex.response?.data || "Failed to pause account";
        toast.error(message);
      }
    }
  };

  handleUnpauseClick = async () => {
    if (window.confirm("Are you sure you want to unpause this user's account? Their subscription end date will be extended by the number of paused days.")) {
      try {
        await http.put("users/unpause/" + this.props.match.params.id);
        toast.success("Account successfully unpaused");
        await this.loadUserDetails();
      } catch (ex) {
        const message = ex.response?.data || "Failed to unpause account";
        toast.error(message);
      }
    }
  };

  handleToggleAutorenewals = async () => {
    if (window.confirm("do you want to toggle autorenewals?")) {
      await http.post("billingprofiles/toggle/" + this.props.match.params.id);
      await this.loadBillingProfile();
      toast.success("billing profile successfully toggled");
    }
  };

  render() {
    // if (!this.state.isLoaded) return null;
    const id = this.props.match.params.id;
    const isNewUser = id === "new";

    return (
      <Container>
        <AdminPermission user={auth.getCurrentUser()}>
          <UserForm userId={id} />
        </AdminPermission>
        <CustomerServicePermission user={auth.getCurrentUser()}>
          <UserCustomerServiceForm userId={id} />
        </CustomerServicePermission>
        {isNewUser ? null : (
          <>
            <Row>
              <Col>
                <BlockedWebsitesTable userId={id} />
              </Col>
            </Row>
            <Row>
              <Col>
                <SearchProfilesTable userId={id} />
              </Col>
            </Row>
            <Row>
              <Col>
                <DefaultPanelContainer title="Payments">
                  <PaymentsTable minRows={4} endpoint={"payments/user/" + id} />
                </DefaultPanelContainer>
              </Col>
            </Row>
            <Row>
              <Col>
                <SubscriptionsTable userId={id} />
              </Col>
            </Row>
            <Row>
              <Col>
                <BillingProfile
                  billingProfile={this.state.billingProfile}
                  // onCancel={this.handleCancelBillingProfileClick}
                  onToggleAutorenewals={this.handleToggleAutorenewals}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <UserParsedHouseEventsTable
                  title="Parsed houses"
                  getUrl={() =>
                    "userparsedhouseevent/user/" + this.props.match.params.id
                  }
                  userId={this.props.match.params.id}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <MessagesTable userId={this.props.match.params.id} />
              </Col>
            </Row>
            <Row>
              <Col>
                <UserListingStatusesTable userId={this.props.match.params.id} />
              </Col>
            </Row>
            {this.state.userDetails?.isPaused && (
              <Row>
                <Col className="my-3">
                  <div className="alert alert-warning">
                    <strong>Account Paused</strong>
                    {this.state.userDetails.pausedDate && (
                      <span> since {new Date(this.state.userDetails.pausedDate).toLocaleDateString()}</span>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col className="my-3 col-2">
                {this.state.userDetails?.isPaused ? (
                  <Button color="success" onClick={this.handleUnpauseClick}>
                    Unpause Account
                  </Button>
                ) : (
                  <Button color="warning" onClick={this.handlePauseClick}>
                    Pause Account
                  </Button>
                )}
              </Col>
              <Col className="my-3 col-2">
                <Button color="danger" onClick={this.handleUnsubscribeClick}>
                  {" "}
                  Unsubscribe{" "}
                </Button>
              </Col>
              <Col className="my-3 col-2">
                <Button
                  color="danger"
                  onClick={this.handleUnsubscribeAndNotifyClick}
                >
                  Unsubscribe and notify user
                </Button>
              </Col>
              <Col className="my-3 col-2">
                <Button color="danger" onClick={this.handleDeleteForeverClick}>
                  {" "}
                  Delete forever{" "}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Container>
    );
  }
}

export default UserDetails;
